import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "consumable-material-add-edit-modal",
    attrs: {
      "width": 800,
      "data-sign": "consumable_material_add_edit_modal",
      "title": _vm.rowData.title
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "data-sign": "consumable_material_add_edit_form",
      "model": _vm.formData
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8017\u6750\u7C7B\u578B"),
      "prop": "consumable_type",
      "label": _vm.t('耗材类型')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "disabled": _vm.isEdit,
      "placeholder": _vm.t('请选择耗材类型')
    },
    model: {
      value: _vm.formData.consumable_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "consumable_type", $$v);
      },
      expression: "formData.consumable_type"
    }
  }, _vm._l(_vm.isEdit ? _vm.consumableTypeEnum : _vm.consumableTypeEnableEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.int_value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8017\u6750\u7F16\u7801"),
      "prop": "consumable_code",
      "label": _vm.t('耗材编码')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入耗材编码'),
      "disabled": _vm.isEdit,
      "max-length": 10
    },
    model: {
      value: _vm.formData.consumable_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "consumable_code", $$v);
      },
      expression: "formData.consumable_code"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8017\u6750\u540D\u79F0"),
      "prop": "consumable_name",
      "label": _vm.t('耗材名称')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入耗材名称'),
      "max-length": 20
    },
    model: {
      value: _vm.formData.consumable_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "consumable_name", $$v);
      },
      expression: "formData.consumable_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5907\u6CE8"),
      "prop": "remark",
      "label": _vm.t('备注')
    }
  }, [_c('my-textarea', {
    attrs: {
      "placeholder": _vm.t('请输入备注'),
      "max-length": 255,
      "rows": 3
    },
    model: {
      value: _vm.formData.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "remark", $$v);
      },
      expression: "formData.remark"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "consumable_material_add_cancel",
      "id": "consumable_material_add_cancel",
      "data-sign": "consumable_material_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "data-permission": "consumable_material_add_save",
      "id": "consumable_material_add_save",
      "type": "primary",
      "data-sign": "consumable_material_add_edit_submit",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };